export default "__VITE_ASSET__ZyryuNTD__"